@if (seconds() !== null) {
  <div class="lock-warning" role="alertdialog" aria-live="assertive" id="session-lock-warning">
    <div class="lock-warning__card">
      <nz-icon nzType="lock" nzTheme="outline" class="lock-warning__icon"></nz-icon>
      <h3 class="lock-warning__title">Verrouillage dans {{ seconds() }} s</h3>
      <p class="lock-warning__text">
        Cette session va se verrouiller faute d'activité. Personne ne pourra encaisser sous votre
        identité une fois l'écran verrouillé.
      </p>
      <div class="lock-warning__actions">
        <button
          nz-button
          nzType="primary"
          nzSize="large"
          (click)="stayConnected()"
          id="session-lock-warning-stay-button"
        >
          Je suis là
        </button>
        <button
          nz-button
          nzSize="large"
          (click)="lockNow()"
          id="session-lock-warning-lock-now-button"
        >
          Verrouiller maintenant
        </button>
      </div>
    </div>
  </div>
}
